import React from "react";
class Overlay extends React.Component {
  constructor(props){
	super(props);
    this.state = {
      show: true,
      full_effect: false
	};

    this.on_click_general = this.on_click_general.bind(this);

  }

  componentDidMount(){
    setTimeout(() => {
      this.setState({
        full_effect: true
      });
    }, 100);
  }

  on_click_general(e){
    if (e.target.className === "psintegril-popup-blurred-background"){
        console.log('cancel!!');
      this.props.on_cancel();
    }
  }

  render () {
    return ( this.state.show ?
      <div style={{backdropFilter: this.state.full_effect ? "blur(4px)" : null/*,backgroundColor: "rgb(0, 0, 0, "+String(this.state.full_effect)+")",*/}} onClick={this.on_click_general} className="psintegril-popup-blurred-background">
        <div className="psintegril-overlay-container" 
            style={{...{marginTop: '70px', margin: 'auto'}, ...this.props.style}}>
            {this.props.children}
        </div>
      </div>
    : null);
  }
}

export default Overlay;
